import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function SolidArrowDownIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M12 17L20.9169 8.39995C21.5644 7.77541 21.1223 6.68017 20.2227 6.68017L3.77717 6.68011C2.87752 6.6801 2.43542 7.77535 3.08297 8.39989L12 17Z",
    fill: "currentColor"
  }));
}